module.exports = __webpack_public_path__ + "img/Website logo (Eng)-01.882ae304.jpg";